import { useState, useEffect } from "react";
import axios from "axios";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Facility from "@/components/Facility";
import ServiceTracker from "@/components/ServiceTracker";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [testimonialsRes, faqsRes] = await Promise.all([
          axios.get(`${API}/testimonials`),
          axios.get(`${API}/faqs`)
        ]);
        setTestimonials(testimonialsRes.data);
        setFaqs(faqsRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Facility />
        <ServiceTracker />
        <Testimonials items={testimonials} loading={loading} />
        <FAQ items={faqs} loading={loading} />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
